var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.value &&
    _vm.value.services != null &&
    _vm.value.services.length != 0
    ? _c("div", [
        _vm._m(0),
        _c("hr"),
        _vm.value.services
          ? _c(
              "div",
              { staticClass: "row rounded py-3 mb-3 mt-n2" },
              _vm._l(_vm.value.services, function(item, index) {
                return _c(
                  "div",
                  {
                    key: `item-index-${index}`,
                    staticClass: "col-md-3 col-sm-12 mt-3"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "rounded border border-color--secondary-12 p-3"
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-8" }, [
                            _c("div", { staticClass: "color-gray-7 font-15" }, [
                              _vm._v("Servicio:")
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-gray-7 font-weight-bold font-15"
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(item.serviceDescription) + " "
                                )
                              ]
                            )
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-4 text-right" },
                            [
                              !_vm.paymentJournal.paymentJournalNumber
                                ? _c("action-button", {
                                    staticClass: "outline-danger pr-1",
                                    attrs: {
                                      i: "fa fa-times-circle font-20 pt-1"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$emit("on-delete-relation", {
                                          ...item
                                        })
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ]),
                        _c("div", { staticClass: "row mt-3" }, [
                          _c("div", { staticClass: "col" }, [
                            _c("div", { staticClass: "color-gray-7 font-15" }, [
                              _vm._v("Estudiante:")
                            ]),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "color-gray-7 font-weight-bold font-15"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(item.studentSieId) +
                                    " - " +
                                    _vm._s(item.studentFullName) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("em", { staticClass: "fas fa-people-arrows color-primary-2 mr-2" }),
        _c("span", [_vm._v("Servicios en Relación de Pago")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }